module.exports = __webpack_public_path__ + "img/shanghaijunxiuLOGO.c22aea1b.png";